import { render, staticRenderFns } from "./SendTrainingFeedback.vue?vue&type=template&id=3d5d97a4&scoped=true&"
import script from "./SendTrainingFeedback.vue?vue&type=script&lang=js&"
export * from "./SendTrainingFeedback.vue?vue&type=script&lang=js&"
import style0 from "./SendTrainingFeedback.vue?vue&type=style&index=0&id=3d5d97a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d97a4",
  null
  
)

export default component.exports